import { connect } from 'react-redux';
import * as R from 'ramda';
import ProductCheckboxList from './ProductCheckboxList';
import { fetchProducts } from '../store/sequencingWizardSlice';

const mapState = R.applySpec({
  products: R.path(['loadingManagement', 'sequencingWizard', 'products']),
  productsLoading: R.path(['loadingManagement', 'sequencingWizard', 'productsLoading']),
});

const mapDispatch = {
  fetchProducts,
};

export default connect(mapState, mapDispatch)(ProductCheckboxList);
